import React, { useCallback } from 'react';
import { StageNode } from './StageNode';
import { useProcessing } from '../context';
import { ConnectionStatus } from './ConnectionStatus';
import { StageState } from '../types';

export const StatusTree: React.FC = () => {
  const { state: processingState, dispatch } = useProcessing();

  const handleStageToggle = useCallback((index: number) => {
    dispatch({
      type: 'TOGGLE_STAGE',
      payload: { stageIndex: index },
    });
  }, [dispatch]);

  return (
    <div className="status-tree">
      <ConnectionStatus 
        status={processingState.connectionStatus}
        error={null}
      />
      
      {processingState.stages.map((stage: StageState, index: number) => (
        <StageNode
          key={`${stage.id}-${index}`}
          stage={stage}
          onToggle={() => handleStageToggle(index)}
        />
      ))}
    </div>
  );
}; 